import { render, staticRenderFns } from "./NormalSearchNav205.vue?vue&type=template&id=6210f94a&scoped=true&"
import script from "./NormalSearchNav205.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav205.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6210f94a",
  null
  
)

export default component.exports